export const CONST_LABEL_LOCAL_GOV = "Municipality /City / District";
export const LABEL_DIVISION = "Division / Sub-Count / Town Council";
export const LABEL_PARISH = "Parish / Ward";
export const LABEL_VILLAGE = "Village  / Cell / Zone";
